const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins
export class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.expanded = false
  }

  render () {
    fetch(this.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendationsCheck = html.querySelector('[data-push-cart-recommendations-carousel-el="slides"]')
        const recommendations = html.querySelector('push-cart-recommendations')
        const hasItems =
          recommendations && recommendationsCheck.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.psh-Recommendations')
            .forEach(container => {
              container.innerHTML = recommendations.innerHTML
            })
        }

        this.expanded = !!hasItems
      })
      .catch(e => {
        console.error(e)
      })
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('site-drawer[key="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded)

    document
      .querySelector('.psh-Cart_Recommendations')
      ?.setAttribute('loaded', expanded)
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}

class PushCartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 500)
    // this.render()
  }

  render () {
    if (!this.els?.slide?.exists) return

    this.isMediumBreakpoint = false

    if (window.BAO.MediaBreakpoints.isMd) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('resize', () => this.onResize())
  }

  onResize () {
    const isCurrentlyMediumBreakpoint = window.BAO.MediaBreakpoints.isMd

    if (isCurrentlyMediumBreakpoint && this.carousel && !this.isMediumBreakpoint) {
      this.carousel.destroy()
      this.carousel = null
      this.isMediumBreakpoint = true
    } else if (!isCurrentlyMediumBreakpoint && !this.carousel) {
      this.isMediumBreakpoint = false
      this.carousel = this.setupCarousel()
    }
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.75,
          spacing: 10,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('push-cart-recommendations-carousel')) {
  customElements.define(
    'push-cart-recommendations-carousel',
    PushCartRecommendationsCarousel,
  )
}
